import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { TurnoverEditMode } from './components/turnoverEditMode/TurnoverEditMode'
import { TurnoverLargeFormatEditMode } from './components/turnoverEditMode/TurnoverLargeFormatEditMode'
import { TurnoverLargeFormatReadMode } from './components/turnoverReadMode/TurnoverLargeFormatReadMode'
import { TurnoverReadMode } from './components/turnoverReadMode/TurnoverReadMode'
import { getFieldLabelTranslation } from './helpers/getFieldLabelTranslation'
import { getPpsShareInputLabelTranslation } from './helpers/getPpsShareInputLabelTranslation'
import { ITurnoverAccessProps, TTurnoverProps } from './models/turnoverProps'
import { TRANSLATION_KEYS } from './translations'

import styles from './Turnover.module.scss'

export const Turnover: FC<TTurnoverProps & ITurnoverAccessProps> = (props) => {
  const { isDistributor, isLargeFormatMode, isRetail, fYear } = props
  const isEditMode = useSelector(selectPublishingMode)

  const turnoverFieldLabelTranslation = useMemo(
    () =>
      getFieldLabelTranslation({
        isLargeFormatMode,
        isDistributor,
        isRetail,
      }),
    [isLargeFormatMode, isRetail, isDistributor]
  )

  const ppsShareFieldLabelTranslation = useMemo(
    () =>
      getPpsShareInputLabelTranslation({
        isRetail,
        isDistributor,
      }),
    [isRetail, isDistributor]
  )

  const pYear = useMemo(() => (fYear ? fYear - 1 : 0), [fYear])

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={turnoverFieldLabelTranslation} fYear={pYear} />
      {!props.isLargeFormatMode && (
        <>
          {!isEditMode && (
            <TurnoverReadMode
              turnoverLabelKey={TRANSLATION_KEYS.turnoverInput}
              ppsShareLabelKey={ppsShareFieldLabelTranslation}
              turnover={props.turnover}
              ppsShare={props.ppsShare}
            />
          )}
          {isEditMode && (
            <TurnoverEditMode
              turnoverLabelKey={TRANSLATION_KEYS.turnoverInput}
              ppsShareLabelKey={ppsShareFieldLabelTranslation}
              turnover={props.turnover}
              ppsShare={props.ppsShare}
              isRetail={isRetail}
            />
          )}
        </>
      )}

      {props.isLargeFormatMode && (
        <>
          {!isEditMode && (
            <TurnoverLargeFormatReadMode
              turnoverLabelKey={TRANSLATION_KEYS.turnoverInput}
              turnover={props.turnover}
            />
          )}
          {isEditMode && (
            <TurnoverLargeFormatEditMode
              turnoverLabelKey={TRANSLATION_KEYS.turnoverInput}
              turnover={props.turnover}
            />
          )}
        </>
      )}
    </div>
  )
}
